import { StyleSheet } from 'react-native';
export default StyleSheet.create({
  popupContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 210,
    justifyContent: 'space-around'
  },
  popupMessage: {
    flex: 0.5
  },
  popupButtonContainer: {
    display: 'flex',
    flex: 0.5,
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: 10,
    marginBottom: 25,
    marginRight: 10
  },
}
);


